"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: Do we want to remove any type?
const CircularDependencyException_1 = __importDefault(require("./CircularDependencyException"));
const exception_1 = require("@almservices-cl/exception");
// TODO: Is generic type needed here? This function is always invoked with string[] as first argument
const arrayRemove = (array, value) => {
    return array.filter((item) => {
        return item.toString() !== value.toString();
    });
};
class Container {
    constructor(entries, recipes) {
        // type-coverage:ignore-next-line
        this.instances = new Map();
        this.factories = new Map();
        this.recipes = new Map();
        this.inCreation = [];
        this.applyingRecipes = [];
        this.scheduledRecipes = [];
        this.level = 0;
        this.warmUp = async () => { };
        if (entries) {
            const e = entries;
            Object.keys(e).forEach((entryName) => {
                this.registerFactory(entryName, e[entryName]);
            });
        }
        if (recipes) {
            const r = recipes;
            Object.keys(r).forEach((recipeName) => {
                this.registerRecipe(recipeName, r[recipeName]);
            });
        }
    }
    registerFactory(key, factory) {
        this.factories.set(key, factory);
    }
    registerRecipe(key, recipe) {
        this.recipes.set(key, recipe);
    }
    registerValue(key, value) {
        this.instances.set(key, value);
    }
    // type-coverage:ignore-next-line
    get(key) {
        if (!this.has(key)) {
            this.level++;
            this.create(key);
            this.level--;
            if (this.level === 0) {
                this.applyScheduledRecipes();
            }
        }
        return this.instances.get(key);
    }
    has(key) {
        return this.instances.has(key);
    }
    create(key) {
        const factory = this.factories.get(key);
        if (factory === undefined) {
            throw new exception_1.OutOfRangeException(`There are no factory registered for ${key}`);
        }
        if (this.inCreation.includes(key)) {
            const e = new CircularDependencyException_1.default(`${this.inCreation.join("->")} makes ${this.inCreation[0]} impossible to create`);
            // clear up
            this.inCreation = [];
            throw e;
        }
        this.inCreation.push(key);
        const instance = factory(this);
        this.instances.set(key, instance);
        this.inCreation = arrayRemove(this.inCreation, key);
        if (this.recipes.has(key) &&
            !this.applyingRecipes.includes(key) &&
            !this.scheduledRecipes.includes(key)) {
            this.scheduledRecipes.push(key);
        }
    }
    applyRecipe(name, instance, recipe) {
        this.applyingRecipes.push(name);
        recipe(instance, this);
        arrayRemove(this.applyingRecipes, name);
    }
    applyScheduledRecipes() {
        this.scheduledRecipes.forEach((name) => {
            this.scheduledRecipes = arrayRemove(this.scheduledRecipes, name);
            const instance = this.get(name);
            const recipe = this.recipes.get(name);
            this.applyRecipe(name, instance, recipe);
        });
    }
}
exports.default = Container;
//# sourceMappingURL=Container.js.map